import { createContext, useContext, RefObject } from 'react';

const PageBottomPortalContext = createContext<RefObject<HTMLDivElement | null> | null>(null);

export const PageBottomPortalProvider = ({
  children,
  containerRef,
}: {
  children: React.ReactNode;
  containerRef: RefObject<HTMLDivElement | null>;
}) => <PageBottomPortalContext.Provider value={containerRef}>{children}</PageBottomPortalContext.Provider>;

export const usePageBottomPortal = () => {
  const containerRef = useContext(PageBottomPortalContext);

  if (!containerRef) {
    throw new Error('usePageBottomPortal must be used within PageBottomPortalProvider');
  }

  return containerRef;
};
